import React from 'react'
import "../styles/Settings_Subscriptions.css"
import SubscriptionCard from '../widgets/SubscriptionCard';
import { AppObject } from '../widgets/AppCard';
import NoApps from '../widgets/NoApps';
import { Theme } from '@fluentui/react'; 
import BasePage from '../widgets/BasePage';
import { useTranslation } from 'react-i18next';

type EntObject = {
  apps: string[],
  subscriptions: string[],
}

type SubscriptionProps = {
  appsObj: AppObject[],
  entObj: EntObject,
  currentUser: string,
  tid: string,
  theme?: Theme,
  themeName?: string,
  showNewOnly?: boolean,
  onReloadRequest: React.Dispatch<void>,
}

const Subscriptions: React.FC<SubscriptionProps> = (props: SubscriptionProps) => {
  const { t } = useTranslation();

  // Compute synchronously — no useEffect flash
  const subscriptions = props.entObj?.subscriptions ?? [];
  const hasActiveApps = subscriptions.length > 0;
  const hasPendingApps = subscriptions.some(sub => {
    const obj = JSON.parse(JSON.stringify(sub));
    return obj.saasSubscriptionStatus.trim() === "PendingFulfillmentStart";
  });
  
  return (
    <div id='setsubscontainer' >
      <h3>{t('subscriptionsManagement')}</h3>
      <p />
      {props.showNewOnly && (<label style={{ fontWeight: 'bold', marginBottom: '5px' }}>{t('newSubsNote')}</label>)}
      <div id='setsubinternalcontainer'>
        {props.appsObj && props.entObj && (
          props.entObj?.subscriptions?.map((sub) => {
            const obj = JSON.parse(JSON.stringify(sub));
            if(!props.showNewOnly) return (<SubscriptionCard subscription={obj} key={obj?.id} apps={props.appsObj} currentUser={props.currentUser} tid={props.tid} theme={props.theme} themeName={props.themeName} onReloadRequest={props.onReloadRequest}/>)
            else if (obj.saasSubscriptionStatus.trim() === "PendingFulfillmentStart") return (<SubscriptionCard subscription={obj} key={obj?.id} apps={props.appsObj} currentUser={props.currentUser} tid={props.tid} theme={props.theme} themeName={props.themeName} onReloadRequest={props.onReloadRequest}/>)
            else return (<></>);
          })
        )}
         {props.showNewOnly && !hasPendingApps && (<BasePage/>)}
         {!props.showNewOnly && !hasActiveApps && (<BasePage/>)}
      </div>
    </div>
  )
}

export default Subscriptions
